export enum KidnapAndExtortionMembershipOptions {
  AutoRenewal = 'autoRenewal',
  SendWelcomeEmail = 'sendWelcomeEmail',
  EmailOptOut = 'emailOptout',
}
